var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import "../CopyAndPaste.css";
import { useDelay } from "../hooks/useDelay";
import { useWindowEventListener } from "../../common/hooks/useWindowEventListener";
import { InternalContentPreview } from "./InternalContentPreview";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Header from "@cloudscape-design/components/header";
import FormField from "@cloudscape-design/components/form-field";
import copy from "copy-to-clipboard";
/**
 * Allow users to copy to local device and/or paste to remote session.
 */
export var CopyAndPaste = function (_a) {
    var _b = _a.content, content = _b === void 0 ? "" : _b, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.disableCopyFromRemote, disableCopyFromRemote = _d === void 0 ? false : _d, _e = _a.disablePasteToRemote, disablePasteToRemote = _e === void 0 ? false : _e, props = __rest(_a, ["content", "isLoading", "disableCopyFromRemote", "disablePasteToRemote"]);
    var _f = useState(), popover = _f[0], setPopover = _f[1];
    var _g = useState(false), popoverVisible = _g[0], _setPopoverVisible = _g[1];
    var _h = useDelay(function () {
        _setPopoverVisible(false);
    }), setHidePopoverDelay = _h[0], clearHidePopoverDelay = _h[1];
    var setPopoverVisible = function (value) {
        _setPopoverVisible(value);
        if (value) {
            setHidePopoverDelay();
        }
        else {
            clearHidePopoverDelay();
        }
    };
    useWindowEventListener("copy", function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var success, copiedText, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    if (!props.onCopyFromRemote) {
                        return [2 /*return*/];
                    }
                    if (isLoading) {
                        setPopoverVisible(false);
                        return [2 /*return*/];
                    }
                    if (disableCopyFromRemote) {
                        setPopoverVisible(true);
                        setPopover({
                            status: "warning",
                            message: props.i18nStrings.copyFromRemoteDisabled,
                        });
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, props.onCopyFromRemote()];
                case 2:
                    copiedText = _b.sent();
                    /*
                     * If the `copiedText` is undefined, null, or empty string(""),
                     * we will set `false`, because it is not expected value to be copied.
                     */
                    success = copiedText ? copy(copiedText) : false;
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    success = false;
                    return [3 /*break*/, 4];
                case 4:
                    if (success) {
                        setPopover({
                            status: "success",
                            message: props.i18nStrings.copyFromRemoteSuccess,
                        });
                    }
                    else {
                        setPopover({
                            status: "error",
                            message: props.i18nStrings.copyFromRemoteFailed,
                        });
                    }
                    setPopoverVisible(true);
                    return [2 /*return*/];
            }
        });
    }); }, [
        props.onCopyFromRemote,
        isLoading,
        disableCopyFromRemote,
        JSON.stringify(props.i18nStrings),
    ]);
    useWindowEventListener("paste", function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var success, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    event.preventDefault();
                    if (!props.onPasteToRemote) {
                        return [2 /*return*/];
                    }
                    if (isLoading) {
                        setPopoverVisible(false);
                        return [2 /*return*/];
                    }
                    if (disablePasteToRemote) {
                        setPopover({
                            status: "warning",
                            message: props.i18nStrings.pasteToRemoteDisabled,
                        });
                        setPopoverVisible(true);
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, props.onPasteToRemote(event)];
                case 2:
                    success = _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    success = false;
                    return [3 /*break*/, 4];
                case 4:
                    if (success) {
                        setPopover({
                            status: "success",
                            message: props.i18nStrings.pasteToRemoteSuccess,
                        });
                    }
                    else {
                        setPopover({
                            status: "error",
                            message: props.i18nStrings.pasteToRemoteFailed,
                        });
                    }
                    setPopoverVisible(true);
                    return [2 /*return*/];
            }
        });
    }); }, [
        props.onPasteToRemote,
        isLoading,
        disablePasteToRemote,
        JSON.stringify(props.i18nStrings),
    ]);
    return (_jsxs(SpaceBetween, __assign({ size: "m" }, { children: [_jsx(Header, __assign({ variant: "h2", description: props.description }, { children: props.title })), _jsx(FormField, __assign({ stretch: true, label: props.label, controlId: props.controlId }, { children: _jsx(InternalContentPreview, { isLoading: isLoading, content: content, placeholder: props.placeholder, popoverVisible: popoverVisible, popover: popover }) }))] })));
};
